import { Component, Input, ViewChild, EventEmitter, Output } from '@angular/core';
import { MatMenuTrigger } from '@angular/material/menu';
import { Clipboard } from '@angular/cdk/clipboard';
import { IObjectiveConversational } from 'src/app/interfaces/iobjective-conversational';
import {IScoreDetails} from 'src/app/interfaces/iresults-conversational';
import { IScoreOverallConversational } from 'src/app/interfaces/iscore-overall-conversational';
import { PracticeType } from 'src/app/utils/enums/result/resultConversational.enum';
import { AmplitudeService } from 'src/app/services/external-tools/amplitude.service';
import { AmplitudeTrackingEvents } from 'src/app/utils/enums/amplitude/amplitudeTrackingEvents.enum';
import { TranslocoService } from '@jsverse/transloco';
import { TranslationService } from 'src/app/services/translation.service';
import { AppConstants } from 'src/app/app-constants';
import { LocaleService } from 'src/app/services/locale.service';

@Component({
  selector: 'app-new-objectives',
  templateUrl: './new-objectives.component.html',
  styleUrls: ['./new-objectives.component.scss'],
  standalone: false
})
export class NewObjectivesComponent {
  @Input() practiceCallUuid: string = "";
  @Input() scoreCriteria: number = 0;
  @Input() objectives: IObjectiveConversational[] | undefined = undefined;
  @Input() weightAverage: IScoreDetails | undefined = undefined;
  @ViewChild(MatMenuTrigger) tooltipMenu!: MatMenuTrigger;

  @Input() overallScoreWithOneSection: string | undefined = undefined;
  @Input() scoreOverall: IScoreOverallConversational | undefined = undefined;
  @Input() practiceType: string | undefined = "PRACTICE";
  @Input() remainingAttempts: number | undefined = 0;
  @Input() isMaxAttemptsReached: boolean = false;
  @Input() scoredAt: string = "";
  @Input() callType: string | undefined = "CONVERSATIONAL";
  @Input() assignmentStatus: string | undefined;
  @Input() hideCallButton: boolean = false;

  @Output() callBtnClicked = new EventEmitter<void>();
  translationLoaded: boolean = false;
  AppConstants: typeof AppConstants = AppConstants;

  constructor(
    private clipboard: Clipboard,
    private amplitudeService: AmplitudeService,
    private translocoService: TranslocoService,
    private translationService: TranslationService,
    protected localeService: LocaleService,

  ) { }

  ngOnInit() {
    this.translationService.loadScopedTranslation('results').then(() => {
      this.translationLoaded = true;
    })

    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.OBJECTIVE_PAGE_VIEW, {
      'call_type': this.callType,
      'assignment_type': this.practiceType,
    });
  }

  copyText() {
    this.clipboard.copy(this.practiceCallUuid);
    this.tooltipMenu.openMenu();

    setTimeout(() => {
      this.tooltipMenu.closeMenu();
    }, 3000); 
  }

  practiceAgain(event: Event) {
    this.amplitudeService.trackEvent(AmplitudeTrackingEvents.OBJECTIVE_CLICK_PRACTICE_AGAIN, {
      'call_type': this.callType,
      'assignment_type': this.practiceType
    });
    this.callBtnClicked.emit();
  }

  getButtonText() {
    if (this.practiceType === PracticeType.CERTIFICATION)
      return `${this.translocoService.translate('TRY_AGAIN', {}, 'results')}`;
    else if (this.practiceType === PracticeType.PRACTICE)
      return `${this.translocoService.translate('PRACTICE_AGAIN', {}, 'results')}`;
    else return `${this.translocoService.translate('PRACTICE_AGAIN', {}, 'results')}`;
  }
}
